/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config} from 'Utils';
import {getShipmentReportList, dmsPurchaseList, getReportType} from '../../service/reportForm';
import {Store, Actions} from './store';

class DiscountedReport extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelId = window.sessionStorage.getItem('cur_channelId');
        this.state = {
            opts: ['发运含折让报表'],
            channelCode: this.channelId,
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            totalAmount: '',
            searchObj: {
                salesChannelCode: this.channelId,
                s: 10,
                p: 1,
                salesUnitId: "",
                itemDesc: '', //物料描述
                itemNum: '',//物料编码
                orderNumber: '',//订单编号
                confirmDateBegin: '', //开始日期
                confirmDateEnd: '', //结束日期
                shipType: '',
                proLine: ''
            },
            objType_type: [],
            categoryData: [],
            button_limits_end: {},
            loading: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.changeHandle = this.changeHandle.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goView(url) {
        hashHistory.push(url);
    }

    goAdd() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/shipmentReport/exportExcel`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        // const ids = this.state.selectedRowKeys.join('&proIds=');
        // url += `&proIds=${ids}`;
        window.open(url);
    }

    goChange() {
        this.setState({saveVisible: !this.state.saveVisible});
    }

    goDelete() {
        alert('正在删除');
    }

    changeHandle({item, key, keyPath}) {
        this.setState({key});
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                s: 10,
                p: 1,
                salesUnitId: "",
                itemDesc: '',
                itemNum: '',
                orderNumber: '',
                confirmDateBegin: '',
                confirmDateEnd: '',
                shipType: '',
                proLine: '',
                salesChannelCode: this.channelId,
            }
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        if (!this.state.searchObj.confirmDateBegin || this.state.searchObj.confirmDateBegin == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.confirmDateEnd || this.state.searchObj.confirmDateEnd == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            },
            loading: true
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        // if (name == 'shipTime') {
        // 	this.setState({
        // 		searchObj: {
        // 		  ...this.state.searchObj,
        // 		  confirmDateBegin: value.from + ' 00:00:00',
        // 		  endCreatedDate: value.end + ' 23:59:59'
        // 		}
        // 	  })
        // } else {
        // 	this.setState({searchObj: {...this.state.searchObj, [name]: value}});
        // }
        if (name === 'date') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    confirmDateBegin: value.from,
                    // endCreatedDate: value.end
                    confirmDateEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    // updateProductStatusFn (key) {
    // 	/* 产品上下架 */
    // 	if (this.state.selectedRowKeys.length === 0) {
    // 		openNotice('warning', '请选择产品');
    // 		return;
    // 	}
    // 	let params = {
    // 		'ids': this.state.selectedRowKeys
    // 	};
    // 	let self = this;
    // 	if (key == 'up') {
    // 		setProductUp(params).then(function (result) {
    // 			if (result && result.code == 200) {
    // 				openNotice('success', '上架操作成功', '');
    // 				self.initData();
    // 			} else {
    // 				openNotice('error', '上架操作失败', (result && result.message) ? result.message : '');
    // 			}
    // 		});
    // 	} else {
    // 		setProductDown(params).then(function (result) {
    // 			if (result && result.code == 200) {
    // 				openNotice('success', '下架操作成功', '');
    // 				self.initData();
    // 			} else {
    // 				openNotice('error', '下架操作失败', (result && result.message) ? result.message : '');
    // 			}
    // 		});
    // 	}
    // }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        this.setState({
            loading: true
        })
        getShipmentReportList(searchObj).then((result => {
            self.setState({
                loading: false,
                'rows': result.data || [],
                'total': result.total || 1,
                'totalAmount': result.dataMap ? result.dataMap.total : 0
            });
        }))

    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
    }

    componentDidMount() {
        let self = this;
        dmsPurchaseList({channelCode: this.state.channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        getReportType({
            sKey: 'SHIPMENT_REPORT_TYPE'
        }).then(res => {
            if (res.code === 200) {
                const data = res.data || [];
                const arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                data.forEach(item => {
                    arr.push({
                        text: item.name,
                        value: item.name
                    })
                });
                this.setState({objType_type: arr})
            }

        });
        //this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    render() {
        const {opts, key, rows, total, searchObj, selectedRowKeys, objType_type, loading, gouxiaoUnitList} = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'date',//startCreatedDate, endCreatedDate
                    label: '发运日期',
                    options: [
                        {text: '从'},
                        {text: '至'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.confirmDateBegin || '',
                        end: searchObj.confirmDateEnd || ''
                    }
                }, {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '请输入关键字',
                    type: 'select',
                    options: gouxiaoUnitList,
                    showSearch: true,
                    defaultValue: searchObj.salesUnitId
                }, {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '请输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                }, {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                }, {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                }, {
                    name: 'shipType',
                    label: '类型',
                    text: '请选择类型',
                    options: objType_type,
                    defaultValue: searchObj.shipType,
                    multiple: false,//支持多选
                    type: 'select'
                }, {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                }, {
                    name: 'proLine',
                    label: '产品线',
                    text: '选择产品线',
                    options: [
                        {value: '', text: '全部'},
                        {value: '01', text: '元器件'},
                        {value: '02', text: '电工'},
                        {value: '03', text: '电表'},
                        {value: '04', text: '变频器'},
                        {value: '05', text: '天e'},
                        {value: '06', text: 'TG精品'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.proLine
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,
            rowKey: 'RN',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 3500, y: false},
            columns: [
                {
                    title: '出库单号',
                    dataIndex: 'DELIVERYID',
                },
                {
                    title: '发运日期',
                    dataIndex: 'CONFIRMDATE',
                }, {
                    title: '登记日期',
                    dataIndex: 'BOOKEDDATE',
                }, {
                    title: '订购日期',
                    dataIndex: 'ORDEREDDATE',
                }, {
                    title: '类型',
                    dataIndex: 'SHIPTYPE',
                }, {
                    title: '付款方式',
                    dataIndex: 'PAYMENT'
                }, {
                    title: '购货单位',
                    dataIndex: 'SALESUNITNAME',
                }, {
                    title: '提货组织',
                    dataIndex: 'ORGANIZATIONNAME',
                }, {
                    title: '订单类型',
                    dataIndex: 'ORDERTYPE',
                }, {
                    title: '订单编号',
                    dataIndex: 'ORDERNUMBER',
                }, {
                    title: '物料编码',
                    dataIndex: 'ITEMNUM',
                }, {
                    title: '物料说明',
                    dataIndex: 'ITEMDESC',
                    width: 200
                }, {
                    title: '明细类',
                    dataIndex: 'DETAILCAT',
                }, {
                    title: '数量',
                    dataIndex: 'QUANTITY',
                }, {
                    title: '牌价',
                    dataIndex: 'UNITLISTPRICE',
                }, {
                    title: '牌价金额',
                    dataIndex: 'LISTAMOUNT',
                }, {
                    title: '基础下浮率',
                    dataIndex: 'JCXF',
                }, {
                    title: '基础下浮价',
                    dataIndex: 'JCXFJ',
                }, {
                    title: '基础下浮金额',
                    dataIndex: 'JCXFAMOUNT',
                }, {
                    title: '签约下浮额',
                    dataIndex: 'QYXFE',
                }, {
                    title: '最终下浮率',
                    dataIndex: 'ZZXF',
                }, {
                    title: '销售单价',
                    dataIndex: 'UNITSELLINGPRICE',
                }, {
                    title: '销售金额',
                    dataIndex: 'SELLINGAMOUNT',
                }, {
                    title: '销售金额(考核)',
                    dataIndex: 'ORDERAMOUNTKH',
                }, {
                    title: '开单折扣率',
                    dataIndex: 'DISCOUNTRATE',
                }, {
                    title: '折扣金额',
                    dataIndex: 'DISCOUNTAMOUNT',
                }, {
                    title: '返利结算基数',
                    dataIndex: 'FLCK',
                }, {
                    title: '特价追加',
                    dataIndex: 'TJZJ',
                }, {
                    title: '销售折让',
                    dataIndex: 'XSZR',
                },
                {
                    title: '促销追加',
                    dataIndex: 'CXZJ',
                }, {
                    title: '促销大点',
                    dataIndex: 'CXDD',
                }, {
                    title: '推广折让',
                    dataIndex: 'TGZR',
                }, {
                    title: '特殊订单折让',
                    dataIndex: 'TSDDZR',
                }, {
                    title: '规范经营奖折让',
                    dataIndex: 'GFJYZR',
                }, {
                    title: '退货扣点',
                    dataIndex: 'THKD',
                }, {
                    title: '产品大类',
                    dataIndex: 'ABCTYPE',
                }, {
                    title: '产品类别',
                    dataIndex: 'DETAILTYPE',
                }, {
                    title: '折扣比例',
                    dataIndex: 'ZKBL',
                }, {
                    title: '服务费比例',
                    dataIndex: 'FWFBL',
                }, {
                    title: '价格单号',
                    dataIndex: 'SPECIALOFFERCODE',
                }, {
                    title: '是否享受事后折扣',
                    dataIndex: 'ENJOYDISCOUNT',
                }, {
                    title: '业务类型',
                    dataIndex: 'BUSINESSTYPE',
                }, {
                    title: '业务线',
                    dataIndex: 'BUSINESSLINE',
                }, {
                    title: '经销商分类',
                    dataIndex: 'DEALERCATEGORY',
                }, {
                    title: '库存属性',
                    dataIndex: 'STOCKTYPE',
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key} onChange={this.changeHandle}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <span style={{color:'red'}}>协议业绩不包括退货扣点</span>
                    <Button onClick={this.goAdd.bind(this)} icon="export"
                            style={{position: 'absolute', bottom: 8, right: 0}}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
                <p>销售金额合计：{this.state.totalAmount}</p>
            </div>
        </div>
    }
}
;
export default withRouter(DiscountedReport);



// WEBPACK FOOTER //
// ./src/routes/reportForm/discountedReport.js